/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S17_HeadingInputs */

const tr_mesafeli_s17_heading = /** @type {(inputs: Mesafeli_S17_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`17. Fikri Haklar`)
};

const en_mesafeli_s17_heading = /** @type {(inputs: Mesafeli_S17_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`17. Intellectual Property Rights`)
};

const de_mesafeli_s17_heading = /** @type {(inputs: Mesafeli_S17_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`17. Geistige Eigentumsrechte`)
};

const ru_mesafeli_s17_heading = /** @type {(inputs: Mesafeli_S17_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`17. Права интеллектуальной собственности`)
};

/**
* | output |
* | --- |
* | "17. Intellectual Property Rights" |
*
* @param {Mesafeli_S17_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s17_heading = /** @type {((inputs?: Mesafeli_S17_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S17_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s17_heading(inputs)
	if (locale === "de") return de_mesafeli_s17_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s17_heading(inputs)
	return tr_mesafeli_s17_heading(inputs)
});